import { find, last } from 'lodash'

import { Page } from 'common/interfaces'

export function getSteps(path: string[], allSteps: Page[]): Page[] {
  const steps: Page[] = path.map((id) => find(allSteps, { id })!)

  let currentStep = last(steps)!
  while (currentStep.transitions.length === 1) {
    const nextStep = find(allSteps, { id: currentStep.transitions[0].destination })!
    steps.push(nextStep)
    currentStep = nextStep
  }

  const compressedSteps = [steps[0]]
  steps.forEach((step) => {
    if (last(compressedSteps)?.name !== step.name) {
      compressedSteps.push(step)
    }
  })

  return compressedSteps
}
